window.Currency = window.Currency || {};

const Currency = (function () {
  let formatString;

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    if (!window.lang) {
      window.lang = "en";
    }

    if(window.shopMarket == 'sa'){
      if (window.lang === "en") {
        formatString = format || "{{amount}} SR";
      } else {
        console.log("working else");
        formatString = format || " ريال{{amount}}";
      }
    }
    else{
      if (window.lang === "en") {
        formatString = format || "AED {{amount}}";
      } else {
        console.log("working else");
        formatString = format || "د.إ {{amount}}";
      }
    }

    

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    const valueNumber = value ? value.substring(0, value.length - 3) : null;
    return formatString.replace(placeholderRegex, String(valueNumber) + ".00");
  }

  return {
    formatMoney: formatMoney,
  };
})();

window.Currency = Currency;
export default Currency;
